var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { subtitle: "Manage users and their details." },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Users", search: "users" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { dark: "", color: "success" },
              on: {
                click: function ($event) {
                  _vm.showAddUser = !_vm.showAddUser
                },
              },
            },
            [
              _c("v-icon", [_vm._v("add")]),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("Button.Add_a_new_user")) + "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.userList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.UserName)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Email)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.UserRole)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: props.item.IsSysAdmin,
                                    expression: "props.item.IsSysAdmin",
                                  },
                                ],
                                attrs: { color: "success" },
                              },
                              [_vm._v("check")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !props.item.IsSysAdmin,
                                    expression: "!props.item.IsSysAdmin",
                                  },
                                ],
                                attrs: { color: "delete" },
                              },
                              [_vm._v("close")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: props.item.IsTenantAdmin,
                                    expression: "props.item.IsTenantAdmin",
                                  },
                                ],
                                attrs: { color: "success" },
                              },
                              [_vm._v("check")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !props.item.IsTenantAdmin,
                                    expression: "!props.item.IsTenantAdmin",
                                  },
                                ],
                                attrs: { color: "delete" },
                              },
                              [_vm._v("close")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: props.item.IsServiceAccount,
                                    expression: "props.item.IsServiceAccount",
                                  },
                                ],
                                attrs: { color: "success" },
                              },
                              [_vm._v("check")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !props.item.IsServiceAccount,
                                    expression: "!props.item.IsServiceAccount",
                                  },
                                ],
                                attrs: { color: "delete" },
                              },
                              [_vm._v("close")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            props.item.IsLockedOut
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      dark: "",
                                      small: "",
                                      color: "teal accent-4",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.unlockUser = !_vm.unlockUser
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [_vm._v("lock_open")]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("Button.Unlock")) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  depressed: "",
                                  disabled:
                                    _vm.areSameName(
                                      _vm.username,
                                      props.item.UserName
                                    ) || props.item.IsServiceAccount,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showUserDetail = !_vm.showUserDetail
                                    _vm.userDetail = props.item
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Button.Edit_Detail")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  depressed: "",
                                  disabled: props.item.IsServiceAccount,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showEditPassword = !_vm.showEditPassword
                                    _vm.userDetail = props.item
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Button.Edit_Password")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  depressed: "",
                                  color: "error",
                                  disabled:
                                    _vm.areSameName(
                                      _vm.username,
                                      props.item.UserName
                                    ) || props.item.IsServiceAccount,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialog = true
                                    _vm.deleteUser = props.item.UserName
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("delete_forever")]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Remove")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Remove user")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("AdministrationUserManage.confirmTitleMsg", {
                        msg: _vm.deleteUser,
                      })
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("AdministrationUserManage.confirmTextMsg"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.agreeDeleteUser()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("delete_forever")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Remove")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.CANCEL")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AdministrationUnlockUserDialog", { attrs: { show: _vm.unlockUser } }),
      _vm._v(" "),
      _c("AdministrationEditUserDetailDialog", {
        attrs: { show: _vm.showUserDetail, userDetail: _vm.userDetail },
      }),
      _vm._v(" "),
      _c("AdministrationEditUserPasswordDialog", {
        attrs: { show: _vm.showEditPassword, userDetail: _vm.userDetail },
      }),
      _vm._v(" "),
      _c("AdministrationAddUserDetailDialog", {
        attrs: { show: _vm.showAddUser },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }